import {Controller} from "@hotwired/stimulus";

export default class extends Controller {

    connect() {
        console.log('lookup connect')
    }

    async fetchAndPopulate(event) {
        this.element.classList.add("opacity-50");

        let currentElement = event.currentTarget;
        let lookupType = currentElement.dataset.lookupType;
        let currentValue = currentElement.value;
        let data_url = currentElement.dataset.url;
        let identifier = currentElement.dataset.identifier;
        let pattern = currentElement.dataset.pattern


        try {
            let url = `${data_url}?lookup_type=${lookupType}&value=${currentValue}&identifier=${identifier}`;
            let response;
            if (pattern) {
                if (pattern.test(currentValue.toUpperCase())) {
                    response = await fetch(url);
                } else {
                    return
                }
            } else {
                response = await fetch(url);
            }


                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                let fieldsData = await response.json();
                fieldsData.forEach(field => {
                    try {
                        let elementToUpdate = document.getElementById(field.field_id);

                        if (elementToUpdate) {
                            if (field.field_type === 'text') {
                                elementToUpdate.value = field.value;
                            } else if (field.field_type === 'select') {
                                if (elementToUpdate.tomselect) {
                                    elementToUpdate.tomselect.setValue(field.value);
                                } else {
                                    console.warn(`Tom Select instance not found for element with ID: ${field.field_id}`);
                                    elementToUpdate.value = field.value;
                                }
                            }
                        } else {
                            console.warn(`Element with ID: ${field.field_id} not found.`);
                        }
                    } catch (error) {
                        console.error(`Error updating field ${field.field_id}:`, error);
                    }
                });
            }
        catch
            (error)
            {
                console.error("Failed to fetch and populate form:", error);
            }
        finally
            {
                this.element.classList.remove("opacity-50");
            }
        }
    }
